import { createActionTypes } from "../../helpers/utils/createActionTypes"

export const ROLES = {
  GET_ITEM: createActionTypes("GET_USER_ROLES")
}